/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ValidationTypeEnumResponse {
    MIN_VALUE = 'MinValue',
    MAX_VALUE = 'MaxValue',
    REQUIRED_FOR_PREREGISTRATION = 'RequiredForPreregistration',
    REQUIRED_FOR_MEASUREMENT = 'RequiredForMeasurement',
    MIN_SUM = 'MinSum',
    MAX_SUM = 'MaxSum',
    MIN_CHAR_LENGTH = 'MinCharLength',
    MAX_CHAR_LENGTH = 'MaxCharLength',
    MIN_ALLOWED_OPTIONS = 'MinAllowedOptions',
    MAX_ALLOWED_OPTIONS = 'MaxAllowedOptions',
}